"use client";

import React, { createContext, useContext } from "react";

import type { BrandConfig } from "@/utils/whitelabel";

type WhitelabelContextValue = BrandConfig;

const WhitelabelContext = createContext<WhitelabelContextValue | undefined>(
  undefined
);

interface WhitelabelProviderProps {
  children: React.ReactNode;
  config: BrandConfig;
}

export const WhitelabelProvider = ({
  children,
  config,
}: WhitelabelProviderProps) => {
  return (
    <WhitelabelContext.Provider value={config}>
      {children}
    </WhitelabelContext.Provider>
  );
};

export default WhitelabelProvider;

export const useWhitelabel = (): WhitelabelContextValue => {
  const context = useContext(WhitelabelContext);
  if (context === undefined) {
    throw new Error("useWhitelabel must be used within a WhitelabelProvider");
  }
  return context;
};
